module.exports = __webpack_public_path__ + "static/media/background.9caf48d6.jpg";